import {
    URLAPI,
    RESULT_STATES_PATH,
    RESULT_STATE_CREATE_PATH,
    RESULT_STATE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_result_states: {
        data: [],
        status: 0,
        message: {},
    },
    _create_result_state: {
        data: {},
        status: 0,
        message: {},
    },
    _update_result_state: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_RESULT_STATES = "GET_ALL_RESULT_STATES";
export const CREATE_RESULT_STATE = "CREATE_RESULT_STATE";
export const UPDATE_RESULT_STATE = "UPDATE_RESULT_STATE";

export const result_states_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_RESULT_STATES:
            return {
                ...state,
                _get_all_result_states: action.payload,
            };
        case CREATE_RESULT_STATE:
            return {
                ...state,
                _create_result_state: action.payload,
            };
        case UPDATE_RESULT_STATE:
            return {
                ...state,
                _update_result_state: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllResultStates = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${RESULT_STATES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_RESULT_STATES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_RESULT_STATES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_RESULT_STATES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createResultState = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${RESULT_STATE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_RESULT_STATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_RESULT_STATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_RESULT_STATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateResultState = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${RESULT_STATE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_RESULT_STATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_RESULT_STATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_RESULT_STATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_result_states = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
